import type {AxiosError} from 'axios';
import {useMutation, type UseMutationOptions, type UseMutationResult} from 'react-query';
import {
	resendRecoveryCode,
	type ResendRecoveryCodeErrorResponse,
	type ResendRecoveryCodeRequest,
	type ResendRecoveryCodeResponse,
} from '../../http';

export function useResendRecoveryCode(
	options?: UseMutationOptions<
		ResendRecoveryCodeResponse,
		AxiosError<ResendRecoveryCodeErrorResponse>,
		ResendRecoveryCodeRequest
	>,
): UseMutationResult<ResendRecoveryCodeResponse, AxiosError<ResendRecoveryCodeErrorResponse>, ResendRecoveryCodeRequest> {
	return useMutation<ResendRecoveryCodeResponse, AxiosError<ResendRecoveryCodeErrorResponse>, ResendRecoveryCodeRequest>(
		(request) => resendRecoveryCode(request).then(({data}) => data),
		options,
	);
}
